import Token from 'markdown-it/lib/token';
import { ParseSpec } from 'prosemirror-markdown';
import { NodeSpec } from 'prosemirror-model';

import { BaseExtension } from '@lyearn/lygo-core';

import { NODE_NAME } from './consts';
import plugins from './plugins';
import { ImageLayoutTypes } from './types';

export default class Image extends BaseExtension {
  get schema(): NodeSpec {
    return {
      attrs: {
        src: {
          default: null,
        },
        srcset: {
          default: null,
        },
        alt: {
          default: null,
        },
        file: {
          default: null,
        },
        width: {
          default: null,
        },
        height: {
          default: null,
        },
        maxHeight: {
          default: null,
        },
        caption: {
          default: null,
        },
        layout: {
          default: ImageLayoutTypes.Card,
        },
        hotspots: {
          default: null,
        },
        hotspotsEnabled: {
          default: null,
        },
        className: {
          default: null,
        },
        isUploadingExternally: {
          default: false,
        },
        disableResizing: {
          default: false,
        },
        generativeTaskId: {
          default: null,
        },
        generationStatus: {
          default: null,
        },
        parentType: {
          default: null,
        },
        parentId: {
          default: null,
        },
        rootType: {
          default: null,
        },
        rootId: {
          default: null,
        },
        title: {
          default: null,
        },
        description: {
          default: null,
        },
        redirectLink: {
          default: null,
        },
      },
      group: 'block',
      isAtom: true,
      parseDOM: [
        {
          tag: 'img[src]',
          getAttrs: (dom: any) => {
            return {
              src: dom.src,
              srcset: dom.srcset,
              alt: dom.alt || dom.src,
            };
          },
        },
      ],
      toDOM: (node) => {
        let src = node?.attrs?.src;
        return ['img', { ...node.attrs }];
        return src
          ? ['div', { class: 'flex justify-center mt-16' }, ['img', { ...node.attrs }]]
          : ['div'];
      },
    };
  }

  plugins = plugins;

  get name(): string {
    return NODE_NAME;
  }

  get markdownToken(): string {
    return 'image';
  }

  parseMarkdown(): void | ParseSpec {
    return {
      node: NODE_NAME,
      getAttrs: (token: Token) => {
        return {
          src: token.attrGet('src'),
          srcset: token.attrGet('srcset'),
          alt: token.attrGet('alt') || token.content,
        };
      },
    };
  }
}
